import Button from '@material-ui/core/Button'
import React, { ChangeEventHandler, useEffect, useState } from 'react'
import { useStyles } from '../pages/styled'

import CircularProgress from '@material-ui/core/CircularProgress'
import { specialTheme } from '../theme'
import useGa4 from '../hooks/useGa4'
import { useGa4Context } from '../context/Ga4Context'

type UploadButtonProps = {
  name: string
  children: any
  onChange: ChangeEventHandler<HTMLInputElement>
  loading: boolean
  props?: any
  disabled?: boolean
}

const UploadButton = ({
  name,
  children,
  props,
  onChange,
  loading,
  disabled = false,
}: UploadButtonProps) => {
  const classes = useStyles()
  const ga4 = useGa4()
  const ga4Data = useGa4Context().ga4Data

  const [trigger, setTrigger] = useState(false)

  /* Při standardním použití se handleClick (z neznámého důvodu) volá 2x
  * Tento workaround je ohavný, ale nějak funguje */
  const handleClick = (e: any) => {
    setTrigger(true)
    setTimeout(() => {
      setTrigger(false)
    }, 0)
  }

  useEffect(() => {
    if (trigger)
      ga4.ga4_formFieldClick({ case_type: ga4Data?.case_type, step: ga4Data?.step, form_name: ga4Data?.form_name, field_name: name })
  }, [trigger, ga4, ga4Data, name])

  return (
    <Button
      variant="contained"
      component="label"
      className={classes.uploadButton}
      onClick={handleClick}
      {...props}
      disabled={disabled}
    >
      {!loading ? (
        children
      ) : (
        <div color={specialTheme.colors.darkRed}>
          <CircularProgress
            color="inherit"
            size="1.5rem"
          />
        </div>
      )}
      {!loading ? (
        <input
          accept=".bmp,.xls,.xlsx,.gif,.jpeg,.jpg,.png,.heic,.pdf,.doc,.docx,.txt"
          id="attachments"
          onChange={onChange}
          name={'attachments'}
          type="file"
          multiple
          hidden
        />
      ) : null}
    </Button>
  )
}

export default UploadButton
